<h5 class="mb-4">
  <strong>Basic Usage</strong>
</h5>
<div class="mb-5">
  <ngb-rating [(rate)]="currentRate"></ngb-rating>
  <hr>
  <pre>Rate: <b>{{currentRate}}</b></pre>
</div>